import gql from 'graphql-tag';
export default gql`
  query getQuoteDetail($dbQuoteId: String) {
    getQuoteDetail(dbQuoteId: $dbQuoteId) {
      dbquote {
        id
        docusign_ref
        org_id
        quote_status_code
      }
      erpquote {
        erpQuoteRef
        status
        product {
          id
          name
          description
        }
        make {
          id
          name
          description
        }
        bodyType {
          id
          name
        }
        model {
          id
          name
        }
        variant {
          id
          imageUrl
          listPrice
          listPriceGross
          modelYear
          trim
          derivative
          fuelType
          transmission
          transmissionGroupId
          engineDescription
          driveTrain
          seats
        }
        leaseStart
        leaseEnd
        leaseTerm
        kmsPerYear
        availableOptions
        exteriorColour {
          id
          code
          name
          standard
          requires
        }
        interiorColour {
          id
          code
          name
          standard
          requires
        }
        optionalEquipment {
          id
          code
          name
          amountNet
          requires
        }
        adhocEquipment {
          id
          name
          amountNet
        }
        customer {
          companyName
          companyAbn
          customerName
          customerContactNumber
          customerContactEmail
          deliveryAddressLine1
          deliveryAddressLine2
          deliverySuburb
          deliveryState
          deliveryPostcode
          deliveryDate
          dealership
          registrationPostcode
        }
        price {
          onRoadCost
          monthlyRentalNet
          weeklyRentalNet
        }
      }
    }
  }
`;
